export const formatColour = (colourObj) => {
  return `rgba(${colourObj.red},${colourObj.green},${colourObj.blue},${
    colourObj.alpha
  })`
}
